import React, { Component } from 'react'
import './listing_finder.scss'
import SearchForm from "./search_form"
import { withNamespaces } from 'react-i18next'

class ListingFinder extends Component {
  render() {
    const { t } = this.props
    return (
      <section styleName="listing-finder">
        <div styleName="caption">
          <h1 styleName="heading">{t('vietnam.title')}</h1>
          <p styleName="heading-description">
            <span>{t('vietnam.subtitle_first')}</span>
            <span> </span>
            <span>{t('vietnam.subtitle_second')}</span>
          </p>
        </div>
        <SearchForm />
      </section>
    )
  }
}

export default withNamespaces('vietnam')(ListingFinder)
